import React, { useState } from 'react';
import axios from 'axios';
import { FiCalendar, FiCheckSquare, FiGrid, FiMessageSquare } from 'react-icons/fi';
import { ChatState } from '../Context/ChatProvider';
import { Button } from '../ui';
import logo from '../assets/gq_full.png';
import giaFull from '../assets/gia_full.webp';
import './login.css';
import { t, getLang } from '../i18n';
import LanguageMenu from '../i18n/LanguageMenu';

export default function Login() {
  const { address } = ChatState();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError(t("Enter your email and password."));
      return;
    }
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post(`${address}/api/user/login`, { user: form });
      localStorage.setItem('userInfo', JSON.stringify(data));
      // tell the server which language this person picked (reminders are written in it)
      await axios.post(`${address}/api/user/language`, { language: getLang() }, { headers: { Authorization: `Bearer ${data.token}` }, timeout: 3000 }).catch(() => {});
      window.location.replace('/dashboard'); // full reload so every provider boots with the new user
    } catch (err) {
      setError(t("Incorrect email or password."));
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login-hero">
        <div className="hero-gia" aria-hidden="true">
          <img src={giaFull} alt="" />
          <span className="hero-gia-bubble">{t("Hi! I'm QIRA, your AI agent. Log in and let's get to work.")}</span>
        </div>
        <div className="hero-inner">
          <img src={logo} alt={t("Good Quality Management")} className="hero-logo" />
          <h1>{t("Your team's home, all in one place.")}</h1>
          <p>{t("Plan work on the board, meet in the virtual office, and keep every conversation in context.")}</p>
          <ul>
            <li><FiCheckSquare /> {t("Jira-style boards, sprints and issue tracking")}</li>
            <li><FiGrid /> {t("A virtual office where your team walks and talks")}</li>
            <li><FiMessageSquare /> {t("Chat, calls and screen sharing")}</li>
            <li><FiCalendar /> {t("Shared calendar with reminders")}</li>
          </ul>
        </div>
      </div>
      <div className="login-form-wrap">
        <div className="login-lang"><LanguageMenu compact={false} /></div>
        <form className="login-form" onSubmit={submit}>
          <h2>{t("Log in to GQ")}</h2>
          <p className="sub">{t("Use your work account to continue.")}</p>
          {error && <div className="login-error" role="alert">{error}</div>}
          <div className="field">
            <label htmlFor="email">{t("Email")}</label>
            <input id="email" className="input" type="email" autoComplete="username" autoFocus value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="field">
            <label htmlFor="password">{t("Password")}</label>
            <input id="password" className="input" type="password" autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button variant="primary" type="submit" disabled={busy} style={{ width: '100%', height: 40 }}>
            {busy ? t("Signing in…") : t("Continue")}
          </Button>
          <p className="sub" style={{ marginTop: 20, textAlign: 'center' }}>
            {t("Don't have an account? Ask your administrator to add you.")}
          </p>
        </form>
      </div>
    </div>
  );
}
